import { core_v1_DataSourceSpec } from '@antimatterhq/asl-api-ts-v1';
import { Fieldset } from '@antimatterhq/ui/components/fieldset';

type Custom = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<core_v1_DataSourceSpec['silver']>['transform']
    >['presetOverrides']
  >['addTables']
>[number]['custom'];

export const CustomNotebookFunctionReview = ({
  custom,
}: {
  custom: Custom;
}) => {
  const functionName = custom?.function ?? '';
  const options = custom?.options ?? {};

  return (
    <div>
      <Fieldset.Field>
        <Fieldset.Label>Custom Notebook Function</Fieldset.Label>
      </Fieldset.Field>
      <Fieldset.List>
        <Fieldset.Field>
          <Fieldset.Label>Function name:</Fieldset.Label>
          <Fieldset.Value>{functionName}</Fieldset.Value>
        </Fieldset.Field>
        <Fieldset.Field>
          <Fieldset.Label>Parameters:</Fieldset.Label>
          <Fieldset.Value>
            {Object.entries(options || {})
              .map(([key, value]) => `${key}:${value}`)
              .join(', ')}
          </Fieldset.Value>
        </Fieldset.Field>
      </Fieldset.List>
    </div>
  );
};
